module.exports = __webpack_public_path__ + "img/validation.0252e2b2.png";